import ModalForm from "./Form";
import { API_VOUCHER_CATEGORY, DATATABLE_EXPORT } from "../../../../Config/ApiUrl";

export const Schema = {
	components: { ModalForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "voucher-category-table",
			rowData: {},
			formId: "voucher-category-form",
			counter: 0,
			tableColumns: [
				// {
				// 	title: "No.",
				// 	type: "text",
				// 	key: "id",
				// 	modifier: (value) => {
				// 		console.log('Value:', value);
				// 		return this.counter += 1;
				// 	}
				// },
				{
					title: this.$t('table_voucher_category_code'),
					type: "text",
					key: "code",
				},
				{
					title: this.$t('table_voucher_category_desc'),
					type: "text",
					key: "description",
				},
				{
					title: this.$t('table_voucher_category_deduction'),
					type: "custom-html",
					key: "deduction",
					modifier: (value) => {
						return this.formattedIDR(value) ?? this.formattedIDR(0);
					},
				},
				{
					title: this.$t('table_voucher_category_created_by'),
					type: "text",
					key: "created_by",
					modifier: (value) => {
						return value ?? false;
					},
				},
				{
					title: this.$t('table_voucher_category_created_at'),
					type: "custom-html",
					key: "created_at",
					modifier: (value) => {
						if (!value) return "-";
						const date = new Date(value);
						if (isNaN(date)) return value;
						const options = { month: "short", day: "2-digit", year: "numeric" };
						return date.toLocaleDateString("en-US", options);
					},
				},
			],
			tableActions: [
				{
					title: this.$t("edit"),
					icon: "edit",
					type: "none",
					component: "app-add-modal",
					modalId: "voucher-category-form",
				},
				// {
				// 	title: this.$t("delete"),
				// 	icon: "trash",
				// 	type: "none",
				// 	className: 'btn btn-danger',
				// 	component: "app-confirmation-modal",
				// 	modalId: "demo-delete",
				// },
			],
			ENDPOINT: API_VOUCHER_CATEGORY,
			actionObj: {
				title: this.$t("action"),
				type: "action",
				key: "actions",
			},
			options: {
				name: "VoucherCategory",
				url: API_VOUCHER_CATEGORY,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [],
				filters: [],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = `${this.ENDPOINT}/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => { })
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(value);
		},
	},
};
